export default __webpack_public_path__ + "static/media/walkyries.794278cb.jpg";